import styled from 'styled-components/macro';
import { FlexAlignRight, FlexJustifyCenter } from '../../../../../shared-styles/flex';

export const BottomRow = styled.div`
  ${FlexAlignRight}
  gap: ${(props) => props.theme.spacing(20)};
  margin-top: ${(props) => props.theme.spacing(8)};
`;

export const LoadingContainer = styled.div`
  ${FlexJustifyCenter}
`;
